import { useMemo } from "react";
import {
  DEFAULT_CREATOR_TESTIMONIAL,
  DEFAULT_RATING_MAX,
} from "./CreatorTestimonial.constants";
import {
  generateStarRatingList,
  formatAuthorTitle,
  formatAuthorRoleSubtitle,
} from "./CreatorTestimonial.utils";

export const useCreatorTestimonial = (testimonialData = {}) => {
  const mergedData = useMemo(() => {
    return {
      ...DEFAULT_CREATOR_TESTIMONIAL,
      ...testimonialData,
    };
  }, [testimonialData]);

  const authorTitle = useMemo(() => {
    return formatAuthorTitle(mergedData.authorName, mergedData.companyName);
  }, [mergedData.authorName, mergedData.companyName]);

  const roleSubtitle = useMemo(() => {
    return formatAuthorRoleSubtitle(mergedData.role, mergedData.subtitle);
  }, [mergedData.role, mergedData.subtitle]);

  const stars = useMemo(() => {
    const max = mergedData.maxStars || DEFAULT_RATING_MAX;
    const numericRating = Math.round(parseFloat(mergedData.rating) || max);
    return generateStarRatingList(max, numericRating);
  }, [mergedData.maxStars, mergedData.rating]);

  return {
    badge: mergedData.badge,
    authorTitle,
    roleSubtitle,
    rating: mergedData.rating,
    stars,
    quote: mergedData.quote,
    photoUrl: mergedData.photoUrl,
    photoPlaceholderText: mergedData.photoPlaceholderText,
  };
};
